import type { DateRange, IsoDate } from "./dates";
import { eachDay, isDateInRange } from "./dates";

export const isDayCovered = (date: IsoDate, windows: DateRange[]): boolean =>
  windows.some((w) => isDateInRange(date, w));

/** Every day of the range must fall inside some availability window (adjacent windows count as continuous). */
export const isRangeCovered = (
  range: DateRange,
  windows: DateRange[]
): boolean => eachDay(range).every((day) => isDayCovered(day, windows));

export type DayStatus =
  "past" | "unavailable" | "available" | "reserved" | "mine";

interface DayStatusContext {
  today: IsoDate;
  windows: DateRange[];
  reservations: (DateRange & { isMine: boolean })[];
}

export const getDayStatus = (
  date: IsoDate,
  { today, windows, reservations }: DayStatusContext
): DayStatus => {
  const reservation = reservations.find((r) => isDateInRange(date, r));
  if (reservation) {
    return reservation.isMine ? "mine" : "reserved";
  }
  if (date < today) {
    return "past";
  }
  return isDayCovered(date, windows) ? "available" : "unavailable";
};
